
import { FormGroup, FormControl, FormArray, Validators } from '@angular/forms';


export function getUpdatePersonnelFileEntryDtoFormGroup() {
return new FormGroup({
    categoryId: new FormControl<number | undefined>(undefined),
    subject: new FormControl<string | undefined>('', [Validators.maxLength(250)]),
    notes: new FormControl<string | undefined>(undefined),
    entryDate: new FormControl<string | undefined>(''),
    confidential: new FormControl<boolean | undefined>(undefined),
})
;
}
      